var _path, _path2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteamCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2635 3.75H19.0133C19.2122 3.75 19.403 3.82902 19.5436 3.96967C19.6843 4.11032 19.7633 4.30109 19.7633 4.5V20.25C19.7633 20.4489 19.6843 20.6397 19.5436 20.7803C19.403 20.921 19.2122 21 19.0133 21H5.51331C5.31439 21 5.12363 20.921 4.98298 20.7803C4.84232 20.6397 4.76331 20.4489 4.76331 20.25V4.5C4.76331 4.30109 4.84232 4.11032 4.98298 3.96967C5.12363 3.82902 5.31439 3.75 5.51331 3.75H9.2631",
    stroke: "#71747C",
    strokeWidth: 1.64575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5144 6.75V6C8.5144 5.00544 8.90949 4.05161 9.61275 3.34835C10.316 2.64509 11.2698 2.25 12.2644 2.25C13.259 2.25 14.2128 2.64509 14.9161 3.34835C15.6193 4.05161 16.0144 5.00544 16.0144 6V6.75H8.5144Z",
    stroke: "#71747C",
    strokeWidth: 1.64575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.76233,
    y1: 9.67712,
    x2: 14.5123,
    y2: 9.67712,
    stroke: "#71747C",
    strokeWidth: 1.64575
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.76233,
    y1: 12.6771,
    x2: 12.2623,
    y2: 12.6771,
    stroke: "#71747C",
    strokeWidth: 1.64575
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamCopy);
export default __webpack_public_path__ + "static/media/steam-copy.8abfc710.svg";
export { ForwardRef as ReactComponent };